/**
 * API origin for fetch/axios. Use env in production; empty string uses the same
 * origin as the SPA so Create React App's proxy can forward /api to the backend in dev.
 */
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";
